import React from 'react';
import type { SurveySection } from '../../../types/publicForm.types';
import { FormQuestion } from './FormQuestion';
import { getIconComponent } from './utils/sectionIcons';

interface FormSectionProps {
  section: SurveySection;
  primaryColor: string;
}

export const FormSection: React.FC<FormSectionProps> = ({ section, primaryColor }) => {
  const IconComponent = section.icon ? getIconComponent(section.icon) : null;
  
  // Check if any questions in this section are required
  const hasRequiredQuestions = section.questions?.some(question => question.required);

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      {/* Required Field Legend */}
      {hasRequiredQuestions && (
        <div className="bg-gray-50 rounded-lg px-3 py-2 text-base text-gray-600 mb-4">
          <span className="text-red-600">*</span> indicates a required field
        </div>
      )}

      {(section.title || IconComponent) && (
        <div className="flex items-center gap-3 mb-2">
          {IconComponent && (
            <IconComponent className="h-5 w-5" style={{ color: primaryColor }} />
          )}
          {section.title && (
            <h3 className="text-lg font-medium text-gray-900">
              {section.title}
            </h3>
          )}
        </div>
      )}

      {section.sectionDescription && (
        <div
          className="prose prose-sm max-w-none text-gray-600 mb-6"
          dangerouslySetInnerHTML={{ __html: section.sectionDescription }}
        />
      )}

      <div className="space-y-6">
        {section.questions
          ?.filter(question => !question._destroy)
          .sort((a, b) => (a.order || 0) - (b.order || 0))
          .map((question, index, filteredQuestions) => (
            <div
              key={question.id}
              className={index === filteredQuestions.length - 1 ? "pb-8" : ""}
            >
              <FormQuestion
                question={question}
                primaryColor={primaryColor}
              />
            </div>
          ))}
      </div>
    </div>
  );
};